"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PitchGeometryFactory = void 0;
var tslib_1 = require("tslib");
var homography_1 = require("../homography");
var vector_1 = require("./../vector");
var Project = tslib_1.__importStar(require("./coordinate.projection"));
var geometry_3d_1 = require("./geometry.3d");
var GeoUtil = tslib_1.__importStar(require("./geometry.util"));
var ALIGNMENT_SIZE = 1;
var PitchGeometryFactory = /** @class */ (function () {
    function PitchGeometryFactory() {
    }
    PitchGeometryFactory.prototype.create = function (ctx) {
        return PitchGeometryFactory.create(ctx);
    };
    PitchGeometryFactory.create = function (ctx) {
        var creationContext = {
            planeCenter_MRW: null,
            planeNormal_MRW: null,
            planeAxis_MP: null,
            planeOrigin_MRW: null,
            focalLength: -1,
            calibration: null,
            homography: null,
            ctx: ctx,
            createdBy: geometry_3d_1.Geometry3DCreationMethod.PITCH
        };
        if (ctx.calibration) {
            creationContext.focalLength = ctx.calibration.focal;
            creationContext.calibration = ctx.calibration;
        }
        else {
            creationContext.focalLength = ctx.focalLength || GeoUtil.calculateFocalLength(ctx.resolution, ctx.viewAngle);
        }
        creationContext.planeOrigin_MRW = creationContext.planeCenter_MRW = new vector_1.Vector(0, 0, ctx.distance * -1);
        creationContext.planeNormal_MRW = new vector_1.Vector(0, Math.sin(ctx.pitch), Math.cos(ctx.pitch));
        creationContext.planeAxis_MP = { x: null, y: null };
        creationContext.planeAxis_MP.x = new vector_1.Vector(-1, 0, 0);
        creationContext.planeAxis_MP.y = creationContext.planeNormal_MRW.cross(creationContext.planeAxis_MP.x);
        creationContext.homography = PitchGeometryFactory.calculateHomography(creationContext, ctx.resolution);
        return new geometry_3d_1.Geometry3D(creationContext);
    };
    PitchGeometryFactory.calculateHomography = function (ctx, resolution) {
        var alignmentGrid_MP = [
            [0, 0],
            [ALIGNMENT_SIZE, 0],
            [ALIGNMENT_SIZE, ALIGNMENT_SIZE],
            [0, ALIGNMENT_SIZE]
        ].map(vector_1.Vector.create);
        var ProjectMeasureToCalibrated = Project.MeasureToCalibrated.bind(null, ctx.focalLength, ctx.planeOrigin_MRW, ctx.planeAxis_MP, resolution);
        var ProjectCalibratedToImage = Project.CalibratedToImage.bind(null, resolution);
        var alignmentGrid_CI = alignmentGrid_MP.map(ProjectMeasureToCalibrated);
        var alignmentGrid_IP = alignmentGrid_CI.map(ProjectCalibratedToImage);
        return homography_1.Homography.create(alignmentGrid_IP, alignmentGrid_MP);
    };
    return PitchGeometryFactory;
}());
exports.PitchGeometryFactory = PitchGeometryFactory;
//# sourceMappingURL=geometry.factory.pitch.js.map